<template>
  <div>
    <div v-if="!loading">
      <table
        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
        <thead class="table-active">
          <tr>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Fecha
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
              Lugar
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-5">
              Presidente
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-1">
              Acta
            </th>
            <th scope="col" class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in acts" :key="item.id">
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle">
              {{ dateConvert(item.announcement_date) || "-" }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle">
              {{ item.copasst_place || "-" }}
            </td>
            <td :class="`${item.copasst_candidates.length > 0 ? 'text-left' : 'text-center'
              } align-middle px-6 text-sm text-gray-500 mx-2`">
              {{ getPresident(item.copasst_candidates) || "-" }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle">
              <button :disabled="!allowAccess() && !getRole('Consultar')" type="button"
                class="btn btn-outline-primary btn-md" @click="print(item.id)">
                <i class="bx bx-download"></i>
              </button>
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle">
              <b-dropdown variant="primary" dropleft>
                <template v-slot:button-content>
                  <i class="mdi mdi-eye"></i>
                </template>
                <b-dropdown-item :disabled="!allowAccess() && !getRole('Editar')"
                  :href="`/forms/estandares/${companyID}/acta-copasst/${item.id}`">
                  Editar
                </b-dropdown-item>
                <b-dropdown-item :disabled="!allowAccess() && !getRole('Consultar') && !getRole('Crear')"
                  :href="`/forms/estandares/${item.id}/seguimiento-copasst`">
                  Seguimiento
                </b-dropdown-item>
                <b-dropdown-item :disabled="!allowAccess() && !getRole('Consultar')"
                  :href="`/forms/estandares/${companyID}/capacitacion-copasst/${item.id}`">
                  Capacitación
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
    <Pagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
      @fetch="(items) => (acts = items)" />
  </div>
</template>

<script>
import Pagination from "./CopasstPagination";
import { dateFormat } from "@/utils/helpers/format";
import CopasstActAPI from "@/services/standards/copasst/copasstActAPI";
import ItemAPI from "@/services/items/itemsAPI";

export default {
  components: { Pagination },
  data() {
    return {
      acts: [],
      search: null,
      showNotification: false,
      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,

      itemData: null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getPresident(array) {
      if (array.length > 0) {
        const president = array.find((item) => item.president);
        return president ? president.employee.full_name : "-";
      } else {
        return "-";
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      if (date) return dateFormat(date);
      else return "-";
    },

    // Descarga el acta de conformación BRANDED (logo + control + firma del encargado).
    print(actID) {
      window.open(CopasstActAPI.pdfUrl(actID), "_blank");
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },
  },
};
</script>
